export type IProduct = {
  _id: string;
  code: string;
  name: string;
  category: string;
  maximumApplication: number;
  durability: number;
  preventive: boolean;
  corrective: boolean;
  misuse: boolean;
  counterSet: number;
  measuredunit: TYPE_MEASUREDUNIT,
  referencesSet?: string[];
  qtdFrac?: number;
  brand?: string;
  price?: string;
  ncm?: string;
  cst?: string;
}

export enum TYPE_MEASUREDUNIT {
  'CJ' = 'CJ',
  'KIT' = 'KIT',
  'UNID' = 'UNID'
}

export const emptyProduct = () => ({
  code: "",
  name: "",
  category: "",
  maximumApplication: 0,
  durability: 0,
  preventive: false,
  corrective: false,

  misuse: false,
}) as IProduct;
